// src/components/subscription/PaymentModal.jsx

import React, { useState } from 'react';

export default function PaymentModal({ plan, onSuccess, onClose }) {
  const [paymentMethod, setPaymentMethod] = useState('credit_card');
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    cardNumber: '',
    expiryDate: '',
    cvv: '',
    cardHolder: '',
    email: '',
    phone: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Simulate payment processing
    setTimeout(() => {
      // In a real implementation, you would integrate with:
      // - Stripe (for international payments)
      // - PayTR (Turkish payment provider)
      // - İyzico (Turkish payment provider)
      // - Garanti BBVA Virtual POS
      
      const paymentData = {
        method: paymentMethod,
        amount: plan.price,
        currency: 'TRY',
        transactionId: `txn_${Date.now()}`,
        cardLast4: formData.cardNumber.slice(-4),
        status: 'completed'
      };
      
      onSuccess(paymentData);
      setLoading(false);
    }, 2000);
  };

  const inputStyle = {
    width: '100%',
    padding: '12px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '14px',
    marginBottom: '16px'
  };

  const labelStyle = {
    display: 'block',
    marginBottom: '6px',
    fontWeight: 'bold',
    color: '#333'
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1001
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '40px',
        maxWidth: '500px',
        width: '90%',
        maxHeight: '90%',
        overflow: 'auto'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
          <h2 style={{ margin: 0, color: '#333' }}>Ödeme Bilgileri</h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: '#666'
            }}
          >
            ×
          </button>
        </div>

        {/* Plan Summary */}
        <div style={{
          backgroundColor: '#f8f9fa',
          padding: '20px',
          borderRadius: '8px',
          marginBottom: '30px'
        }}>
          <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>{plan.name} Planı</h3>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Aylık ücret:</span>
            <strong style={{ fontSize: '20px', color: '#06C167' }}>{plan.price}₺</strong>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          {/* Payment Method Selection */}
          <div style={{ marginBottom: '24px' }}>
            <label style={labelStyle}>Ödeme Yöntemi</label>
            <div style={{ display: 'flex', gap: '12px' }}>
              <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                <input
                  type="radio"
                  value="credit_card"
                  checked={paymentMethod === 'credit_card'}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                  style={{ marginRight: '8px' }}
                />
                Kredi Kartı
              </label>
              <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                <input
                  type="radio"
                  value="bank_transfer"
                  checked={paymentMethod === 'bank_transfer'}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                  style={{ marginRight: '8px' }}
                />
                Havale/EFT
              </label>
            </div>
          </div>

          {paymentMethod === 'credit_card' && (
            <>
              <div>
                <label style={labelStyle}>Kart Sahibi</label>
                <input
                  type="text"
                  name="cardHolder"
                  value={formData.cardHolder}
                  onChange={handleInputChange}
                  required
                  style={inputStyle}
                  placeholder="Ad Soyad"
                />
              </div>

              <div>
                <label style={labelStyle}>Kart Numarası</label>
                <input
                  type="text"
                  name="cardNumber"
                  value={formData.cardNumber}
                  onChange={handleInputChange}
                  required
                  style={inputStyle}
                  placeholder="1234 5678 9012 3456"
                  maxLength="19"
                />
              </div>

              <div style={{ display: 'flex', gap: '12px' }}>
                <div style={{ flex: 1 }}>
                  <label style={labelStyle}>Son Kullanma</label>
                  <input
                    type="text"
                    name="expiryDate"
                    value={formData.expiryDate}
                    onChange={handleInputChange}
                    required
                    style={inputStyle}
                    placeholder="MM/YY"
                    maxLength="5"
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={labelStyle}>CVV</label>
                  <input
                    type="text"
                    name="cvv"
                    value={formData.cvv}
                    onChange={handleInputChange}
                    required
                    style={inputStyle}
                    placeholder="123"
                    maxLength="4"
                  />
                </div>
              </div>
            </>
          )}

          <div>
            <label style={labelStyle}>E-posta</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
              style={inputStyle}
              placeholder="email@example.com"
            />
          </div>

          <div>
            <label style={labelStyle}>Telefon</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              required
              style={inputStyle}
              placeholder="+90 555 123 45 67"
            />
          </div>

          {paymentMethod === 'bank_transfer' && (
            <div style={{
              backgroundColor: '#e3f2fd',
              padding: '16px',
              borderRadius: '8px',
              marginBottom: '20px'
            }}>
              <h4 style={{ margin: '0 0 10px 0' }}>Havale Bilgileri</h4>
              <p style={{ margin: 0, fontSize: '14px' }}>
                <strong>Banka:</strong> Garanti BBVA<br/>
                <strong>IBAN:</strong> TR12 0062 1000 0000 0000 0000 00<br/>
                <strong>Açıklama:</strong> {plan.name} Planı - Şirket ID
              </p>
            </div>
          )}

          <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
            <button
              type="button"
              onClick={onClose}
              style={{
                flex: 1,
                padding: '12px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                backgroundColor: 'white',
                cursor: 'pointer'
              }}
            >
              İptal
            </button>
            <button
              type="submit"
              disabled={loading}
              style={{
                flex: 2,
                padding: '12px',
                border: 'none',
                borderRadius: '6px',
                backgroundColor: '#06C167',
                color: 'white',
                cursor: loading ? 'default' : 'pointer',
                fontWeight: 'bold',
                opacity: loading ? 0.7 : 1
              }}
            >
              {loading ? 'İşleniyor...' : `${plan.price}₺ Öde`}
            </button>
          </div>
        </form>

        <div style={{
          textAlign: 'center',
          marginTop: '20px',
          fontSize: '12px',
          color: '#666'
        }}>
          <p>🔒 Ödeme bilgileriniz SSL ile korunmaktadır</p>
          <p>İlk 7 gün içinde iptal ederseniz tam iade alırsınız</p>
        </div>
      </div>
    </div>
  );
}